import React, { createContext, useContext, useState, ReactNode } from 'react';

interface GroupExpandedContextType {
  expandedGroups: Record<string, boolean>;
  toggleGroup: (groupName: string) => void;
  setGroupExpanded: (groupName: string, expanded: boolean) => void;
}

const GroupExpandedContext = createContext<GroupExpandedContextType | undefined>(undefined);

interface GroupExpandedProviderProps {
  children: ReactNode;
  initialExpandedGroups?: Record<string, boolean>;
}

export function GroupExpandedProvider({ 
  children, 
  initialExpandedGroups = {} 
}: GroupExpandedProviderProps) {
  const [expandedGroups, setExpandedGroups] = useState<Record<string, boolean>>(
    initialExpandedGroups
  );

  const toggleGroup = (groupName: string) => {
    setExpandedGroups(prev => ({
      ...prev,
      [groupName]: !prev[groupName]
    }));
  };

  const setGroupExpanded = (groupName: string, expanded: boolean) => {
    setExpandedGroups(prev => ({
      ...prev,
      [groupName]: expanded
    }));
  };

  return (
    <GroupExpandedContext.Provider value={{
      expandedGroups,
      toggleGroup,
      setGroupExpanded
    }}>
      {children}
    </GroupExpandedContext.Provider>
  );
}

// Modified to be optional - returns null if no provider instead of throwing
export function useGroupExpanded() {
  const context = useContext(GroupExpandedContext);
  // Return null instead of throwing - TreeNav will handle this gracefully
  return context || null;
}